import { render, staticRenderFns } from "./shareMaPop.vue?vue&type=template&id=522ca752"
import script from "./shareMaPop.vue?vue&type=script&lang=js"
export * from "./shareMaPop.vue?vue&type=script&lang=js"
import style0 from "./shareMaPop.vue?vue&type=style&index=0&id=522ca752&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports